import React from 'react';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useTranslation } from 'react-i18next';
import produce from 'immer';
import { Divider } from '@material-ui/core';
import CardWrapper from 'components/Card/CardWrapper';
import { makeStyles } from '@material-ui/styles';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

import InputsIndex from './InputsIndex';

const useStyles = makeStyles({
  divider: {
    marginBottom: '20px',
  },
  radioGroupContainer: {
    paddingLeft: '32px',
  },
});

const OtherConfiguration = ({ shopModule, setShopModule }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const getValueHandlerByStateKey = stateKey => {
    const fieldProps = {
      value: shopModule?.[stateKey],
      handler: () => {
        setShopModule(
          produce(draft => {
            draft[stateKey] = !draft[stateKey];
          })
        );
      },
    };

    return fieldProps;
  };

  const handleDishesGroupedByChange = value => {
    setShopModule(
      produce(draft => {
        draft.dishesGroupedBy = value;
      })
    );
  };

  const dishesGroupedBy = shopModule?.dishesGroupedBy ?? 'NONE';
  const isDishesGroupedByEnabled = dishesGroupedBy !== 'NONE';

  const fields = [
    {
      label: t('$*shop.otherSettings.showMealTypeFilter'),
      tooltip: t('$*shop.otherSettings.showMealTypeFilter.tooltip'),
      type: 'checkbox',
      ...getValueHandlerByStateKey('showMealTypeSelector'),
    },
    {
      label: t('$*shop.otherSettings.showCalendar'),
      tooltip: t('$*shop.otherSettings.showCalendar.tooltip'),
      type: 'checkbox',
      ...getValueHandlerByStateKey('showCalendar'),
    },
  ];

  return (
    <CardWrapper title={t('$*shop.otherSettings')}>
      <CardBody>
        <Divider className={classes.divider} />
        <GridContainer>
          <GridItem xs={6}>
            <GridContainer>
              <GridItem xs={12}>
                <InputsIndex
                  label={t('$*shop.otherSettings.dishesGroupedBy')}
                  type="checkbox"
                  value={isDishesGroupedByEnabled}
                  handler={() => {
                    handleDishesGroupedByChange(
                      isDishesGroupedByEnabled ? 'NONE' : 'MEAL_TYPE'
                    );
                  }}
                />
                <div className={classes.radioGroupContainer}>
                  <div>
                    <LabeledRadio
                      label={t(
                        '$*shop.otherSettings.dishesGroupedBy.MEAL_TYPE'
                      )}
                      checked={
                        dishesGroupedBy === 'MEAL_TYPE' ||
                        !isDishesGroupedByEnabled
                      }
                      onChange={() => handleDishesGroupedByChange('MEAL_TYPE')}
                      name="dishesGroupedBy"
                      disabled={!isDishesGroupedByEnabled}
                    />
                  </div>
                  <div>
                    <LabeledRadio
                      label={
                        <InfoIconTooltip
                          title={t(
                            '$*shop.otherSettings.dishesGroupedBy.CATEGORY.tooltip'
                          )}
                        >
                          {t('$*shop.otherSettings.dishesGroupedBy.CATEGORY')}
                        </InfoIconTooltip>
                      }
                      checked={dishesGroupedBy === 'CATEGORY'}
                      onChange={() => handleDishesGroupedByChange('CATEGORY')}
                      name="dishesGroupedBy"
                      disabled={!isDishesGroupedByEnabled}
                    />
                  </div>
                </div>
              </GridItem>
            </GridContainer>
            {fields.map((field, index) => (
              <GridContainer key={`field-${index}`}>
                <GridItem xs={12}>
                  <InputsIndex {...field} />
                </GridItem>
              </GridContainer>
            ))}
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default OtherConfiguration;
